// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"102":"xlsx","133":"pdfmake","182":"canvg"}[chunkId] + "." + {"102":"fd6495d1","133":"a820d712","182":"56ff7b49"}[chunkId] + ".chunk.js";
};